export const TRANSLATIONS_ES = {
  "home.intro": `
  <p>Ayesa pone a disposición de su personal empleado y terceros este <strong>CANAL ÉTICO</strong> al objeto de poder comunicar de forma segura y totalmente confidencial cualquier tipo de consulta o irregularidad cometida en el seno de la misma, o en su ámbito de actuación, sobre un hecho que pudiera suponer el incumplimiento de los principios recogidos en el <a href="#">Código Ético</a> y demás normativa interna a la que Ayesa está sujeta.</p>
  <p>La recepción y gestión de las comunicaciones recibidas a través de este canal serán responsabilidad del Órgano de Cumplimiento (Compliance). Ayesa se compromete a no adoptar ningún tipo de represalia frente a aquellos que, de buena fe, pongan en conocimiento de la compañía una supuesta irregularidad o incumplimiento.</p>
  <p>Para mejor entendimiento de la gestión de las consultas y la comunicación de infracciones recibidas a través de este canal, tienen a su disposición la <a href="#">Política de comunicación de infracciones,</a> donde queda regulado su funcionamiento.</p>
  `,

  "home.btnNewCase": "Comunicar una infracción o hacer una consulta",

  "home.btnQuery": "Consultar estado de una comunicación de infracción o de una consulta",

   "home.btnDownload": "Disable Descargar el Código Ético en formato PDF",
  
  
    "thankyou.label": "Gracias",
  
    "details.label": "esto es una prueba",
  
    "Advantages.label": "Ventajas",
  
    "Advantagesdetails.label": "es muy facil"
  
  };